import { observer } from 'mobx-react-lite';
import Frame from '../../../uikit/Frame';
import Box from '../../../uikit/Box';
import DocViewer from '../../common/DocViewer';

const AccountDeletePage = observer(() => {
    return (
        <Frame>
            <Frame.Title title="계정 및 데이터 삭제 안내" />
            <Box>
                <DocViewer docKey={'account-delete'} />
            </Box>
        </Frame>
    );
});

export default AccountDeletePage;
